import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { ElectricBolt as ElectricBoltIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function ChargerModal({ open, onClose, slotNumber, address }) {
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="charger-modal-title"
    >
      <DialogTitle id="charger-modal-title" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ElectricBoltIcon color="warning" />
        <Typography variant="h6" component="span">
          {t('bookings.charger_warning_title')}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="body2">
            {t('bookings.charger_booking_confirmed')}
          </Typography>
        </Alert>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            <strong>{t('bookings.your_booking')}:</strong>
          </Typography>
          <Typography variant="body2" sx={{ ml: 2 }}>
            🅿️ {t('bookings.slot')} {slotNumber}<br/>
            📍 {address}
          </Typography>
        </Box>

        <Box sx={{ p: 2, bgcolor: 'warning.light', borderRadius: 1, border: '1px solid', borderColor: 'warning.main' }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
            ⚡ {t('bookings.charger_important_note')}:
          </Typography>
          <Typography variant="body2">
            {t('bookings.charger_shared_message')}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          {t('actions.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChargerModal;


